import { Icon, Text } from "@smartsuite/react-ui/lib";
import type React from "react";

import { texts } from "./BrowserStorageRequired.text";

export const BrowserStorageRequired: React.FC = () => {
  return (
    <section className="browser-storage-required">
      <div className="browser-storage-required__content">
        <Icon className="browser-storage-required__icon" name="database-off-thin" size="MISC" />
        <Text className="browser-storage-required__title" size="xl" weight="semibold">
          {texts.title}
        </Text>
        <Text className="browser-storage-required__description" size="l">
          {texts.description}
        </Text>
      </div>
    </section>
  );
};
